<mat-form-field [ngStyle]="{ width: '100%', padding: '10px' }" appearance="fill">
	<mat-label>Enter a date range</mat-label>
	<mat-date-range-input [rangePicker]="picker" [formGroup]="form">
		<input matStartDate placeholder="Start date" formControlName="start">
		<input matEndDate placeholder="End date" formControlName="end">
	</mat-date-range-input>
	<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
	<mat-date-range-picker #picker [ngStyle]="{ width: '100%' }" (closed)="handleChange()"></mat-date-range-picker>
</mat-form-field>
